import { MtTag } from "server/models"
import { OrderType } from "client/utils"

export type TagValidation = { [key in keyof MtTag]?: string}

export interface TagList { [tagId: number]: MtTag }
export interface TagFilters {
    search?: string
}

export interface TagState {
    tagList: TagList
    tagIds: readonly number[]
    tagEdit: MtTag

    sortColumn: keyof MtTag
    sortOrder: OrderType
    filters: TagFilters

    reloadList: boolean
}

export const TAG_LIST = "TAG_LIST"
export const TAG_IDS = "TAG_IDS"
export const TAG_EDIT = "TAG_EDIT"

export const TAG_SORT = "TAG_SORT"
export const TAG_FILTERS = "TAG_FILTERS"

export const TAG_RELOAD_LIST = "TAG_RELOAD_LIST"
